import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { GET_VENDOR_LOGIN_REQUEST } from "./type";
import { getVendorLoginSuccess } from "./action";
import { ApiResponseMessage } from "../../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../../constant/commonConstants";
import { invokeApi } from "../../../../helper/axiosHelper";
import { setLoginVendorData } from "../../../../utils/authUtils";


function* login({ payload: data }) {
    try {
        const res = yield call(invokeApi, "post", "/login", data, {}, "vendor");
        if (res.status) {
            setLoginVendorData(res);
            yield put(getVendorLoginSuccess(res));
            ApiResponseMessage(res.message, SUCCESS);
        } else {
            yield put(getVendorLoginSuccess([]));
            ApiResponseMessage(res.message, DANGER);
        }
    } catch (error) {
        ApiResponseMessage(error.message, DANGER);
    }
}

function* watchVendorLoginRequest() {
    yield takeLatest(GET_VENDOR_LOGIN_REQUEST, login);
}

function* VendorLoginSaga() {
    yield all([fork(watchVendorLoginRequest)]);
}

export default VendorLoginSaga;
